import React from 'react';
import { UniversalEditorContext } from '../context/universal-editor-context';
import { findModelAndFragmentForPath } from '../utils';
import { isContentFragment } from '../../content-types';
import { UeElement } from './ue-element';
export const UeReference = ({ propertyPath, behavior, children, as, label, }) => {
    const ueContext = React.useContext(UniversalEditorContext);
    const { resource, finalLabel, lastProperty } = React.useMemo(() => {
        var _a, _b, _c;
        if (!ueContext.isAuthorMode || !ueContext.isFalconContent) {
            return { resource: '', finalLabel: '', lastProperty: '' };
        }
        const modelAndFragment = findModelAndFragmentForPath(ueContext.rawCmsContent, propertyPath);
        if (!isContentFragment(modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.fragment)) {
            console.warn(`We could not find a reference for the propertyPath "${propertyPath}"`);
            return { resource: '', finalLabel: '', lastProperty: '' };
        }
        return {
            resource: (_a = modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.fragment) === null || _a === void 0 ? void 0 : _a.contentPath,
            finalLabel: label || ((_c = (_b = modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.fragment) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.title),
            lastProperty: modelAndFragment === null || modelAndFragment === void 0 ? void 0 : modelAndFragment.lastPropertyName,
        };
    }, [propertyPath, ueContext, label]);
    return (React.createElement(UeElement, { type: "reference", property: behavior === 'component' ? undefined : lastProperty, label: finalLabel, resource: resource, as: as, behavior: behavior }, children));
};
//# sourceMappingURL=ue-reference.js.map